var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIdTxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multi-tone/IDTX"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 25.5C43 34.6125 35.6125 42 26.5 42C17.3875 42 10 34.6125 10 25.5C10 16.3875 17.3875 9 26.5 9C35.6125 9 43 16.3875 43 25.5Z",
    fill: "#DAF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 25.5C43 34.6125 35.6125 42 26.5 42C17.3875 42 10 34.6125 10 25.5C10 16.3875 17.3875 9 26.5 9C35.6125 9 43 16.3875 43 25.5Z",
    stroke: "#08172D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8994 24.5306L29.0914 33.5219C28.9844 33.8643 28.6206 34.0545 28.2794 33.9475L27.8312 33.8084C27.49 33.7014 27.2998 33.3376 27.4068 32.9964L30.2148 24.0052C30.3218 23.664 30.6856 23.4725 31.0268 23.5795L31.475 23.7186C31.8162 23.8256 32.0064 24.1894 31.8994 24.5306Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9896 28.5627L34.9078 32.0246C34.8008 32.3658 34.437 32.5561 34.0958 32.4502L33.6476 32.31C33.3064 32.2042 33.1162 31.8404 33.2232 31.4992L34.305 28.0361C34.412 27.6949 34.7758 27.5035 35.117 27.6105L35.564 27.7507C35.9052 27.8577 36.0954 28.2203 35.9896 28.5627Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0594 26.4241L37.9775 29.886C37.8705 30.2272 37.5067 30.4174 37.1655 30.3116L36.7185 30.1713C36.3773 30.0655 36.1871 29.7017 36.2929 29.3605L37.3748 25.8986C37.4818 25.5562 37.8456 25.3648 38.1868 25.4718L38.635 25.6121C38.9762 25.7191 39.1664 26.0829 39.0594 26.4241Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1728 22.6637L33.355 28.4854C33.248 28.8278 32.8842 29.018 32.543 28.9122L32.0948 28.7719C31.7536 28.665 31.5634 28.3012 31.6704 27.96L33.4894 22.137C33.5952 21.7958 33.959 21.6044 34.3002 21.7114L34.7484 21.8517C35.0896 21.9587 35.2798 22.3225 35.1728 22.6637Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6722 30.6827L30.896 36.3689C30.789 36.7101 30.4253 36.9003 30.0841 36.7957L29.6359 36.6542C29.2947 36.5484 29.1044 36.1846 29.2114 35.8434L30.9876 30.1572C31.0946 29.8148 31.4584 29.6246 31.7996 29.7304L32.2478 29.8707C32.589 29.9777 32.7792 30.3415 32.6722 30.6827Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.136 18.0522C22.136 18.9974 21.3692 19.7642 20.4241 19.7642C19.4777 19.7642 18.7109 18.9974 18.7109 18.0522C18.7109 17.1059 19.4777 16.3403 20.4241 16.3403C21.3692 16.3403 22.136 17.1059 22.136 18.0522Z",
    fill: "#DC5545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4778 22.6185C24.4778 23.5648 23.711 24.3304 22.7659 24.3304C21.8195 24.3304 21.0527 23.5648 21.0527 22.6185C21.0527 21.6733 21.8195 20.9065 22.7659 20.9065C23.711 20.9065 24.4778 21.6733 24.4778 22.6185Z",
    fill: "#0094C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5523 24.8847C20.5523 25.5706 19.9959 26.127 19.3099 26.127C18.6228 26.127 18.0664 25.5706 18.0664 24.8847C18.0664 24.1975 18.6228 23.6411 19.3099 23.6411C19.9959 23.6411 20.5523 24.1975 20.5523 24.8847Z",
    fill: "#0094C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.389 17.279C26.389 17.965 25.8326 18.5225 25.1466 18.5225C24.4607 18.5225 23.9043 17.965 23.9043 17.279C23.9043 16.593 24.4607 16.0367 25.1466 16.0367C25.8326 16.0367 26.389 16.593 26.389 17.279Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6382 27.5074C22.6382 28.1933 22.0818 28.7509 21.3959 28.7509C20.7087 28.7509 20.1523 28.1933 20.1523 27.5074C20.1523 26.8214 20.7087 26.265 21.3959 26.265C22.0818 26.265 22.6382 26.8214 22.6382 27.5074Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4456 28.0112C19.4456 28.6972 18.8892 29.2535 18.2033 29.2535C17.5173 29.2535 16.9609 28.6972 16.9609 28.0112C16.9609 27.324 17.5173 26.7677 18.2033 26.7677C18.8892 26.7677 19.4456 27.324 19.4456 28.0112Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8706 13.889C25.8706 14.575 25.3143 15.1326 24.6283 15.1326C23.9423 15.1326 23.3848 14.575 23.3848 13.889C23.3848 13.2031 23.9423 12.6467 24.6283 12.6467C25.3143 12.6467 25.8706 13.2031 25.8706 13.889Z",
    fill: "#0094C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6234 22.399C17.6234 23.085 17.067 23.6414 16.381 23.6414C15.6951 23.6414 15.1387 23.085 15.1387 22.399C15.1387 21.713 15.6951 21.1555 16.381 21.1555C17.067 21.1555 17.6234 21.713 17.6234 22.399Z",
    fill: "#08172D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5367 32.2326C18.5367 32.9185 17.9803 33.4749 17.2931 33.4749C16.6072 33.4749 16.0508 32.9185 16.0508 32.2326C16.0508 31.5466 16.6072 30.989 17.2931 30.989C17.9803 30.989 18.5367 31.5466 18.5367 32.2326Z",
    fill: "#0094C8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdTxLogo);
export default __webpack_public_path__ + "static/media/idTx_logo.0b77105e2629fc6c928613e9ca5a627b.svg";
export { ForwardRef as ReactComponent };